import { makeAutoObservable } from "mobx";
import { PCrossSellingItem, PCrossSellingItemBehaviour, } from "./PCrossSellingItem";
export class PCrossSellingCreator {
    constructor(params) {
        this.domain = params.domain;
        this.restaurant = params.restaurant;
        this.localizationProvider = params.localizationProvider;
        makeAutoObservable(this);
    }
    get items() {
        return this.domain.items.map((crossSellingItemInstance) => {
            return PCrossSellingItem.create({
                domain: crossSellingItemInstance,
                behaviour: PCrossSellingItemBehaviour.create(crossSellingItemInstance.behaviour),
                localizationProvider: this.localizationProvider,
                restaurant: this.restaurant,
            });
        });
    }
}
